import { useQuery } from "@tanstack/react-query";
import { getCliengoService } from "../services/cliengo.service.js";
export var CliengoQueryKey = /*#__PURE__*/ function(CliengoQueryKey) {
  CliengoQueryKey["user"] = "user";
  CliengoQueryKey["account"] = "account";
  CliengoQueryKey["websites"] = "websites";
  CliengoQueryKey["website"] = "website";
  CliengoQueryKey["chatbotConfigHasAI"] = "chatbot-config-has-ai";
  CliengoQueryKey["appearance"] = "appearance";
  return CliengoQueryKey;
}({});
export const useUserQuery = (extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.user
    ],
    queryFn: ()=>getCliengoService().getMe(),
    staleTime: Infinity,
    ...extraOptions || {}
  });
};
export const useAccountQuery = (extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.account
    ],
    queryFn: ()=>getCliengoService().getAccount(),
    staleTime: Infinity,
    ...extraOptions || {}
  });
};
export const useWebsitesQuery = (extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.websites
    ],
    queryFn: ()=>getCliengoService().getWebsites(),
    staleTime: 60 * 1000 * 60,
    ...extraOptions || {}
  });
};
export const useWebsiteQuery = (websiteId, extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.website,
      websiteId
    ],
    queryFn: ()=>getCliengoService().getWebsite(websiteId),
    staleTime: 60 * 1000 * 60,
    enabled: !!websiteId,
    ...extraOptions || {}
  });
};
export const useAppearanceQuery = (websiteId, extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.appearance,
      websiteId
    ],
    queryFn: ()=>getCliengoService().getAppearance(websiteId),
    staleTime: Infinity,
    enabled: !!websiteId,
    ...extraOptions || {}
  });
};
export const useChatbotConfigHasAIQuery = (websiteId, extraOptions)=>{
  return useQuery({
    queryKey: [
      CliengoQueryKey.chatbotConfigHasAI,
      websiteId
    ],
    queryFn: ()=>getCliengoService().checkConfigHasAI(websiteId),
    staleTime: Infinity,
    enabled: !!websiteId,
    ...extraOptions || {}
  });
};
export const cliengoQueries = {
  user: useUserQuery,
  account: useAccountQuery,
  websites: useWebsitesQuery,
  website: useWebsiteQuery,
  chatbotConfigHasAI: useChatbotConfigHasAIQuery,
  appearance: useAppearanceQuery
};
//# sourceMappingURL=useCliengoQuery.js.map